import React from "react";
import {convertToCSV, funcOrValOr} from "../tools/CommonJS";
import {downloadUri} from "../tools/CommonHtml";
import {Button, TextInput} from "../tools/Inputs";
import {FormBox} from "../tools/UIDialog";
import {msgBox, msgBoxEx, queryOrErr} from "./AppContext";
import {dispUserName} from "./CommonUIComponenets";
import {tailCheck} from "../tools/CommonReact";

export const exportMsg = "Export is in progress. Once ready, you may download it from the Notifications area under Settings > System Health.";
export const socketNotifs = "notifs_updated";

export function ExportButton({title = '', disabled, className = '', ...exportProps}) {
    return <Button
        h="Export" title={title ?? "Export list to a CSV file..."}
        data-test="export-button"
        className={tailCheck(className,"text-sm", "text-prm-light")}
        onClick={() => askExport(exportProps)}
        disabled={!disabled || typeof disabled === "string"? disabled : "No items selected."}/>
}

export function askExport({exportName, api, params, user, ext}) {
    msgBoxEx({
        Elm: FormBox, autoFocus: false, btnOk: "Generate Export", className: "dlg-lg",
        form: [{label: "File name", field: "exportName", cmpt: TextInput, classNameCol2: "grow",
            props: {autoFocus: true, placeholder: "export file name"}}],
        formInit: {exportName: nameExport(funcOrValOr(exportName), ext, user)},
        checkOk: st => {
            if (!st.exportName) return "Value cannot be empty.";
            if (!(/^[a-zA-Z0-9_\-() ]+\.csv$/).test(st.exportName)) return `File name can only contain letters, numbers, underscores, dashes, and parentheses.`;
        },
        onOk: st => queryOrErr({
            api, rsp: r => msgBox(exportMsg),
            params: {
                ...funcOrValOr(params),
                exportName: st.exportName,
                socket: socketNotifs
            }
        })
    });
}

export function nameExport(name, ext, user) {
    const dt = new Date(Date.now() - new Date().getTimezoneOffset() * 60 * 1000).toISOString().split(/[T:.]/);
    return `${name} - ${!user ? "" : `by ${dispUserName(user)} `}${dt[0]} ${dt[1]}_${dt[2]}`
        .replace(/[^a-zA-Z0-9_\-() ]/g, '_') + (ext ?? ".csv");
}

export function downloadFile({api, params, acceptTypes, fQuery, filename, ...props}) {
    (fQuery ?? queryOrErr)({
        api, params, ...props,
        onRsp: rsp => {
            if (acceptTypes?
                !acceptTypes.includes(rsp?.headers.get("content-type")) :
                rsp?.headers.get("content-type")?.startsWith("application/json"))
                return false;
            return rsp.blob().then(blob => downloadUri({blob, filename}));
        }
    });
}

export const downloadFileFromData = (data, filename, keys) =>
    downloadUri({uri: 'data:text/csv;charset=utf-8,%EF%BB%BF' +encodeURIComponent(convertToCSV(data, keys)), filename: nameExport(filename)})

